/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sch_Err_Builtin_TypeInputs */

const en_sch_err_builtin_type = /** @type {(inputs: Sch_Err_Builtin_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Built-in types cannot be deleted. Archive them instead.`)
};

const de_sch_err_builtin_type = /** @type {(inputs: Sch_Err_Builtin_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integrierte Typen lassen sich nicht löschen. Archiviere sie stattdessen.`)
};

/**
* | output |
* | --- |
* | "Built-in types cannot be deleted. Archive them instead." |
*
* @param {Sch_Err_Builtin_TypeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sch_err_builtin_type = /** @type {((inputs?: Sch_Err_Builtin_TypeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sch_Err_Builtin_TypeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sch_err_builtin_type(inputs)
	return en_sch_err_builtin_type(inputs)
});